import React, { useCallback, useState, useEffect } from 'react'
import styled, { css } from 'styled-components'
import { base, LabelContainer, Label } from './style'
import icon from './icon.svg'

function SelectComponent({label, required, onChange, model, ...rest}) {
    const [error, setError] = useState(false) 
    const validate = useCallback((e) => {
        if(e.target.value === "") {
            setError(true)
        } else {
            setError(false)
        }
    }, [])

    const change = useCallback(e => {
        if(required) validate(e)
        if(onChange) onChange(e)
        if(model) model.onChange(e)
    }, [])

    useEffect(() => {
        if(!model) return

        model.ref.current = {
            error: () => {
                setError(true)
            }
        }
    }, [])

    return (
        <LabelContainer>
            <Label>{label}</Label>
            <Select
                error={error} 
                onBlur={validate}
                onChange={change}
                value={model ? model.value : undefined}
                name={model ? model.name : ""}
                {...rest}
            />
            <i></i>
        </LabelContainer>
    )
}

const Select = styled.select`
    ${base}

    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';

    &::-ms-expand {
        display: none;
    }

    + i {
        position: absolute;
        right: 0;
        top: 52px;
        display: block;
        width: 20px;
        height: 10px;

        background-image: url('${icon}');
        background-repeat: no-repeat;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        pointer-events: none;
    }

    ${props => props.error && !props.disabled && css`
        border: 1px solid #FF0000;
    `}
`

export default SelectComponent


// WEBPACK FOOTER //
// ./src/SPRINTA/v3/Form/Select.js